import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '../../../store/hooks';
import Button from '../Button';
import ErrorHandler from '../ErrorHandler';
import Font from '../Font';
import Icon from '../Icon';
import {
  ButtonWrapper,
  ConfirmWrapper,
  HeaderWidget,
  IconPosition,
  Overflow,
  Wrapper
} from './styles';

type WidgetWrapperProps = {
  children: JSX.Element | JSX.Element[] | string;
  disableConfirmButton?: boolean;
  hideConfirmButton?: boolean;
  onClickClose?: () => void;
  onClickConfirm?: () => void;
};

const WidgetWrapper: React.FC<WidgetWrapperProps> = ({
  children,
  disableConfirmButton,
  hideConfirmButton,
  onClickClose,
  onClickConfirm
}) => {
  const { t } = useTranslation();
  const { widgetType } = useAppSelector((state) => state.app);
  const { status, value } = useAppSelector((state) => state.auth);
  const { postProductsRate } = useAppSelector(
    (state) => state.financialCalculator.status
  );
  const { invalidManufacturerCode } = useAppSelector(
    (state) => state.financialCalculator
  );

  const error =
    (status === 'failed' && !value) || postProductsRate === 'failed';

  return (
    <Wrapper $widgetType={widgetType}>
      <Overflow $widgetType={widgetType}>
        <>
          {widgetType === 'modal' ? (
            <HeaderWidget>
              <Font variant="heading3">{t('Header')}</Font>
              <IconPosition>
                <Icon
                  data-testid="close-button"
                  iconName="InterfaceClose"
                  onClick={onClickClose}
                />
              </IconPosition>
            </HeaderWidget>
          ) : null}
          {error ? (
            <ErrorHandler
              error={
                invalidManufacturerCode
                  ? t('ManufacturerCodeIncorrectMsg')
                  : t('ErrorMessage')
              }
            />
          ) : (
            children
          )}
        </>
      </Overflow>

      {!hideConfirmButton && widgetType === 'modal' ? (
        <ConfirmWrapper>
          <ButtonWrapper>
            <Button
              data-testid="confirm-button"
              disabled={disableConfirmButton}
              onClick={onClickConfirm}
              theme="light"
              type="button"
              variant="accent"
            >
              {t('Confirm')}
            </Button>
          </ButtonWrapper>
        </ConfirmWrapper>
      ) : null}
    </Wrapper>
  );
};

export default WidgetWrapper;
